import styled from "@emotion/styled";

import SvgIconEnvelope from "./icon-envelope.svg";

export const Container = styled.div``;

export const IconContainer = styled.div``;

export const StyledSvgIconEnvelope = styled(SvgIconEnvelope)`
  margin-inline-start: 12px;
`;
